import axiosInstance from "../config/axios.js"

const API_BASE = "/ti-report-files"

const tiReportFileCabinetService = {
  // Upload single or multiple files
  uploadFiles: async (tiReportId, clientId, files) => {
    const formData = new FormData()
    formData.append("ti_report_id", tiReportId)
    formData.append("client_id", clientId)

    files.forEach((file) => {
      formData.append("files", file)
    })

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  // Get all files for a TI report
  getFilesByTIReport: async (tiReportId) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { ti_report_id: tiReportId },
    })
    return response.data
  },

  // Get a specific file by ID
  getFileById: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete a single file
  deleteFile: async (fileId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete multiple files
  deleteMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.delete(`${API_BASE}/delete-multiple`, {
      data: { file_ids: fileIds },
    })
    return response.data
  },

  // Download a single file
  downloadFile: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}/download`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download multiple files as ZIP
  downloadMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.get(`${API_BASE}/download-multiple`, {
      params: { file_ids: fileIds },
      responseType: "blob",
    })
    return response.data
  },

  // Download all files for a TI report
  downloadByTIReport: async (tiReportId) => {
    const response = await axiosInstance.get(`${API_BASE}/download-by-ti-report`, {
      params: { ti_report_id: tiReportId },
      responseType: "blob",
    })
    return response.data
  },

  // Download entire file cabinet
  downloadAllCabinet: async () => {
    const response = await axiosInstance.get(`${API_BASE}/download-all-cabinet`, {
      responseType: "blob",
    })
    return response.data
  },
}

export default tiReportFileCabinetService;